import {
  Box,
  Link,
  Typography,
  CardHeader,
  FormGroup,
  Divider,
  Tooltip,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import { CustomCheckBox } from "../utils/CustomCheckBox";
import { generateGtmEvent } from "../../../Helpers";

interface filterObj {
  id: string;
  label: string;
}

interface moduleCardProps {
  filters: string[];
  setFilters: (filters: string[]) => void;
  close: () => void;
  availableFilters: filterObj[];
}

export const ModuleFilterModal = (props: moduleCardProps) => {
  const HandleDataLayer = (
    event: string,
    action: string,
    type: string,
    region: string,
    section: string,
    text: string
  ) => {
    generateGtmEvent({
      event: event,
      action: action,
      name: "onclick",
      type: type,
      region: region,
      section: section,
      text: text,
    });
  };
  return (
    <>
      <CardHeader
        sx={{ padding: "16px 24px" }}
        title={
          <Typography
            id="filter-modal-title"
            variant="h6"
            sx={{ color: "#000000", fontWeight: "bold", fontSize: "20px" }}>
            Filter modules
          </Typography>
        }
        action={
          <Tooltip title="Close" arrow role="tooltip" describeChild>
            <IconButton
              onClick={() => {
                HandleDataLayer(
                  "modal",
                  "close",
                  "click",
                  "main content",
                  " filter modules",
                  "close cross"
                );
                props.close();
              }}
              aria-label="close filter"
              sx={{ color: "#000000" }}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        }
      />
      <Divider />
      <CardContent sx={{ padding: "32px" }}>
        <Typography
          variant="h6"
          sx={{ color: "#000000", fontWeight: "bold", fontSize: "24px" }}>
          Status
        </Typography>
        <FormGroup>
          {props.availableFilters.map((filter) => {
            return (
              <CustomCheckBox
                key={`filteroption-${filter.id}`}
                label={filter.label}
                checked={props.filters.includes(filter.id)}
                emitDataLayer={(checked) => {
                  HandleDataLayer(
                    "select",
                    checked ? "click" : "unclick",
                    "checkbox",
                    "modal",
                    "status",
                    filter.label
                  );
                }}
                onChange={(e) => {
                  if (e.target.checked) {
                    props.setFilters([...props.filters, filter.id]);
                  } else {
                    props.setFilters(props.filters.filter((f) => f !== filter.id));
                  }
                }}
              />
            );
          })}
        </FormGroup>
      </CardContent>
      <Divider />
      <CardActions sx={{ padding: "24px 48px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}>
          <Link
            onClick={() => {
              HandleDataLayer(
                "select",
                "unclick",
                "checkbox",
                "modal",
                "filter modules",
                "clear all"
              );
              props.setFilters([]);
              // props.close(); based on Valeria's comment to not to close the Modal just to clear off the filters
            }}
            href="#"
            variant="body1">
            Clear all
          </Link>
          <Link
            onClick={() => {
              HandleDataLayer(
                "link",
                "click",
                "internal link",
                "modal",
                "filter modules",
                "show results"
              );
              props.close();
            }}
            href="#"
            underline="none">
            <Button
              size="large"
              variant="contained"
              sx={{
                borderRadius: "16px",
                width: "180px",
                height: "62px",
                padding: "0px",
                "&:hover": {
                  transform: "none",
                },
              }}>
              Show results
            </Button>
          </Link>
        </Box>
      </CardActions>
    </>
  );
};
